import { useState } from 'react';
import { Container, Tab, Tabs } from '@mui/material';

import { AppPage } from '@/shared/components';
import PageHeader from '@/shared/components/PageHeader';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import ClipRulesConfig from './ClipRulesConfig';
import ClipRuleActivity from './ClipRuleActivity';

/**
 * Automation settings (C360-2813 / C360-3154).
 *
 * Two tabs: the rules themselves, and a log of what they produced. The log is
 * mounted only while its tab is selected — it polls, and polling behind a
 * hidden tab is pure noise.
 */
const ClipRulesPage = () => {
  const title = 'Automated Clipping';
  const [tab, setTab] = useState<'rules' | 'activity'>('rules');

  useDocumentTitle(title);

  return (
    <AppPage title={title} requiredPermissions={['menu:manage:org']}>
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        <PageHeader
          title={title}
          subtitle="Create rules that automatically clip game events, and review the clips they produce."
        />

        <Tabs value={tab} onChange={(_e, value) => setTab(value)}>
          <Tab value="rules" label="Auto-clip rules" />
          <Tab value="activity" label="Activity log" />
        </Tabs>

        {tab === 'rules' ? <ClipRulesConfig /> : <ClipRuleActivity />}
      </Container>
    </AppPage>
  );
};

export default ClipRulesPage;
